export function ClearCart(){
    localStorage.removeItem("cart"); // Only removes the cart object
}

export function editInstruction(string) {
    // Retrieve the cart object from localStorage and ensure it's an object
    let storage = localStorage.getItem("cart");

    try {
        storage = storage ? JSON.parse(storage) : {}; // Ensure storage is an object
    } catch (error) {
        console.error("Error parsing localStorage cart:", error);
        storage = {}; // Reset storage if corrupted
    }

    // Update the instruction
    storage.instructions = string;

    // Save the updated object back to localStorage
    localStorage.setItem("cart", JSON.stringify(storage)); // ✅ Fix: Store as JSON string
}


